<template>
  <div :class="{ bg: getBgFlag(),shadowStyle: getShadowFlag() }" :data-cy="CY">
    <div @click="toggle">
      <div id="alignment" :style="accgrid"
        :class="{ outline: (border||!openFlag)&&!subAccordion,'cursor-pointer': true,'outline-top': subAccordion }">
        <img v-if="icon" :src="getImgUrl(icon)" :class="size=='sm'? 'iconTitle':'iconWithSubtitle'" alt="ship" />
        <div>
          <div style="display: inline-flex; align-items: center;">
            <div :class="{ title: true,subAccordionTitle: subAccordion==true,textCapitalize: this.textCapitalize,}"
              :style="titleStyle">
              {{title}}
            </div>
            <div style="display: inline-flex; position: relative; left: 20px; align-items: center;">
              <img @click.stop="onDeleteClick" v-if="deleteIcon" :src="getDelIcon()" alt="delete-icon" width="20" height="20" />
              <img @click.stop="onCloneClick" v-if="copyIcon" :src="getCloneIcon()" alt="copy-icon" width="16" height="16" />
          </div>
          </div>
          <div class="subTitle" :style="subTitleStyle">{{subTitle}}</div>
        </div>
        <img src="../assets/grey-arrow.png" :class="{ 'symbol-icon': arrowFlag,rotate: openFlag }" v-if="arrowFlag" />
        <img v-if="symbolFlag" :src="getSymbolImgUrl(openFlag)" class="symbol-icon" alt="" />
      </div>
    </div>
    <div v-if="openFlag" :class="{ content: true,outline: border }">
      <slot>
        <div v-if="formContent" class="progressBar"></div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "SAccordion",
  data() {
    return {
      arrow: true,
      openFlag: false,
      arrowFlag: false,
      symbolFlag: false,
    };
  },
  methods: {
    toggle() {
      this.openFlag=!this.openFlag;
      if (this.openFlag) {
        this.$emit("state","open");
      } else {
        this.$emit("state","close");
      }
    },
    openAccordion() {
      this.openFlag=true;
      this.$emit("state","open");
    },

    getImgUrl(icon) {
      return icon? require("../assets/"+icon):"";
    },
    getSymbolImgUrl(flag) {
      return flag==false? require("../assets/Plus.png"):require("../assets/Minus.png");
    },

    calculateProgressBar() {
      //  show progress bar accordingly here
    },
    getBgFlag() {
      if (this.alwaysShadow) {
        return false;
      } else {
        if (this.subAccordion) {
          return false;
        }
        return this.openFlag===false;
      }
    },
    getShadowFlag() {
      if (this.alwaysShadow) {
        return true;
      } else {
        return this.shadow===true&&this.openFlag===true;
      }
    },

    onDeleteClick(){
      this.$emit('remove', true);
    },
    onCloneClick(){
      this.$emit('copy', true);
    },
    getDelIcon(){
      return require('../assets/delete_outline.png');
    },
    getCloneIcon(){
      return require('../assets/Clone.png');
    }


  },

  computed: {
    getImageCss() {
      // console.log(this.openFlag)
      if (this.openFlag) {
        return {
          "margin-top": "7px",
          "-webkit-transform": "rotate(180deg)",
          "-moz-transform": "rotate(180deg)",
          "-ms-transform": "rotate(180deg)",
          "-o-transform": "rotate(180deg)",
          "transform": "rotate(180deg)"
        }
      }
      else {

        return {
          "margin-top": "7px"
        }
      }
    },
    subTitleStyle() {
      return {
        "font-size": this.subTitleSize+'px !important',

      };
    },
    titleStyle() {
      return {
        "font-size": this.titleSize+'px',
      };
    },
    accgrid() {
      let acccols,colgap,accp;
      if (this.size.localeCompare("sm")===0) {
        accp="24px";
        colgap="16px";
      }
      if (this.size.localeCompare("lg")===0) {
        accp="24px";
        colgap="32px";
      }
      // console.log(this.icon);
      if (this.icon==null) {
        acccols="1fr 16px";
        // console.log(acccols);
      } else {
        acccols="24px 1fr 16px";
      }

      if (this.padding) {
        return {
          "grid-template-columns": acccols,
          "column-gap": colgap,
          "padding-top": accp,
          "padding-bottom": accp,
          "padding-left": this.padding+"px",
          "padding-right": this.padding+"px",
        };
      }

      return {
        "grid-template-columns": acccols,
        "column-gap": colgap,
        padding: accp,
      };
    },
  },
  props: {
    CY: String,
    title: {
      required: true,
      type: String,
    },
    subTitle: {
      required: false,
      type: String,
    },
    icon: {
      required: false,
      type: String,
    },
    open: {
      type: Boolean,
      //   default: false
    },
    formContent: {
      type: Boolean,
      required: false,
    },
    formData: {
      type: Object,
    },
    subAccordion: {
      type: Boolean,
      default: false,
    },
    expandIcon: {
      type: String,
      default: "arrows",
      required: false,
    },
    size: {
      Type: String,
      default: "lg",
      required: false,
    },
    shadow: {
      type: Boolean,default: true,
    },
    padding: {
      type: String,
    },
    titleSize: {
      type: Number,
      default: 16,
    },
    subTitleSize: {
      type: Number,
      default: 14,
    },
    fontWeight: {
      type: Number,
      default: 500,
    },
    border: {
      default: true,
    },
    alwaysShadow: {
      default: false,
    },
    textCapitalize: {
      default: false,
    },
    copyIcon: {
      type: Boolean,
    },
    deleteIcon: {
      type: Boolean,
    }
  },
  mounted() {
    this.openFlag=this.open;

    if (this.formContent&&this.formData) {
      this.calculateProgressBar();
    }
    //  checking choice of expand/collapse icons
    if (this.expandIcon=="arrows") {
      this.arrowFlag=true;
    } else if (this.expandIcon=="symbols") {
      this.symbolFlag=true;
    }
  },
};
</script>

<style scoped>
.symbol-icon {
  font-size: xx-small;
  width: 16px;
}

.bg {
  background-color: var(--white);
}

.rotate {
  transform: rotate(180deg);
}

.progressBar {
  height: 1px;
  width: -webkit-fill-available;
  background-color: #ff0000;
}

.subTitle {
  line-height: 1.8;
  /* line-height: 0; */
}

.outline {
  border: 1px solid #e1e1e1;
}

.outline-top {
  border-top: 1px solid #e1e1e1 !important;

}

.cursor-pointer {
  cursor: pointer;
}

.iconTitle {
  width: 18px;
  height: 18px;
  align-self: center;
  justify-self: center;
}

.iconWithSubtitle {
  width: 30px;
  height: 30px;
  justify-self: center;
  align-self: center;
}

.title {
  text-align: start;
  font-weight: 900;
  width: -webkit-fill-available;
  font-family: "Roboto !important";
  line-height: 1.17;
  text-transform: capitalize;
}

.subAccordionTitle {
  font-size: 14px !important;
}

.subTitle {
  font-size: 14px;
  font-family: "Roboto !important";
  color: black;
  font-weight: 500;
}

.content {
  position: relative;
}

.open-title {
  margin-left: 36px;
  margin-right: 36px;
  cursor: pointer;
  position: absolute;
  margin-top: -10px;
  background-color: #ffffff;
  display: block;
  z-index: 100;
  width: 560px;
  padding-left: 12px;
  padding-right: 12px;
  text-align: end;
}

#alignment {
  display: grid;
  align-items: center;
}

.shadowStyle {
  -webkit-box-shadow: 0 0 20px var(--very-light-pink);
  box-shadow: 0 0 20px var(--very-light-pink);
}

.text-capitalize {
  text-transform: capitalize;
}
</style>